import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { BciWkModalService } from '@bci/webkitbci';
import { ModalTimeoutComponent } from '../modal-timeout/modal-timeout.component';
import { ModalCodeWrongComponent } from '../modal-code-wrong/modal-code-wrong.component';

@Component({
  selector: 'app-countdown',
  templateUrl: './countdown.component.html',
  styleUrls: ['./countdown.component.scss'],
  standalone: false
})
export class CountdownComponent implements OnInit, OnDestroy, OnChanges {
  minutes = 3;
  seconds = 0;
  private intervalId: any;
  @Output() callResendCode: EventEmitter<any> = new EventEmitter();
  @Output() goBack: EventEmitter<any> = new EventEmitter();
  @Input() intents = 0;
  @Input() touched = false;
  @Input() restart = false;

  constructor(private modal: BciWkModalService) {}

  ngOnInit() {
    this.startCountdown();
  }

  ngOnDestroy(): void {
    clearInterval(this.intervalId);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.intents && changes.intents.currentValue >= 3) {
      this.stopCountdown();
      this.openModalCodeWrong();
    }
    if (changes.restart && changes.restart.currentValue) {
      this.minutes = 3;
      this.seconds = 0;
      this.startCountdown();
    }
  }

  startCountdown() {
    this.intervalId = setInterval(() => {
      if (this.minutes === 0 && this.seconds === 0) {
        this.stopCountdown();
        this.handleZeroTime();
      } else {
        this.decrementTime();
      }
    }, 1000);
  }

  decrementTime() {
    this.seconds--;
    if (this.seconds < 0) {
      this.seconds = 59;
      this.minutes--;
    }
  }

  handleZeroTime() {
    if (this.intents === 0 && !this.touched) {
      this.stopCountdown();
      this.goBack.emit();
    }
    if (this.intents < 3 && this.touched) {
      this.openModalTimeout();
    } else if (this.intents === 3 && this.touched) {
      this.openModalCodeWrong();
    }
  }

  stopCountdown() {
    if (this.intervalId !== null) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }

  openModalTimeout() {
    this.modal.open(ModalTimeoutComponent, {
      resendCode: () => this.callResendCode.emit(),
    });
  }

  openModalCodeWrong() {
    this.modal.open(ModalCodeWrongComponent);
  }

  // Método para formatear un número añadiendo un cero delante si es menor que 10
  formatNumber(num: number): string {
    return num < 10 ? `0${num}` : `${num}`;
  }

  // Método para obtener el tiempo completo formateado
  get formattedTime(): string {
    return `${this.formatNumber(this.minutes)}:${this.formatNumber(
      this.seconds
    )}`;
  }
}
